import { render, staticRenderFns } from "./AdsRent.vue?vue&type=template&id=8eaac0ac"
import script from "./AdsRent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdsRent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports